import request from '@/utils/request'

// 标记图书
export function markBook(data) {
  return request({
    url: '/api/book/markBook',
    method: 'post',
    data
  })
}

// 取消收藏
export function cancelStar(data) {
  return request({
    url: '/api/book/cancelStar',
    method: 'post',
    data
  })
}

// 加入书架
export function shelfBook(data) {
  return request({
    url: '/api/book/shelfBook',
    method: 'post',
    data
  })
}

// 图书详情
export function getBookDetail(id) {
  return request({
    url: `/api/book/detail/${id}`,
    method: 'get'
  })
}

// 图书详情
export function getBookCount(id, year) {
  return request({
    url: `/api/book/month/statistics?bookId=${id}&year=${year}`,
    method: 'get'
  })
}
// 图书详情搜索字段
export function getSearchField(data) {
  return request({
    url: `/api/book/all/field`,
    method: 'get',
    params: data
  })
}
// 图书详情搜索字段
export function getSectionTree(id) {
  return request({
    url: `/api/book/sectionTreeNew?bookId=${id}`,
    method: 'get'
  })
}

// 激活教材
export function activeCode(params) {
  return request({
    url: '/api/collegeBookActiveCode/book/update',
    method: 'get',
    params
  })
}

// 获取最新的下载链接
export function getVersionApi(params) {
  return request({
    url: '/api/version/base',
    method: 'get',
    params
  })
}

// 获取订单详情
export function getOrderDetail(bookId) {
  return request({
    url: `/api/personalOrder/pay/detail/${bookId}`,
    method: 'get'
  })
}
// 创建订单
export function createOrder(id) {
  return request({
    url: `/api/personalOrder/order/${id}`,
    method: 'post'
  })
}

// 获取支付链接
export function getPayUrl(channel,data) {
  return request({
    url: `/api/pay/${channel}/order`,
    method: 'post',
    data
  })
}

// 检查支付状态
export function checkPayStatus(transactionId) {
  return request({
    url: `/api/pay/check/${transactionId}`,
    method: 'get'
  })
}

// 检查订单状态
export function getOrderStatus(bookId) {
  return request({
    url: `/api/personalOrder/order/check/${bookId}`,
    method: 'get'
  })
}

// 获取图书额外信息
export function bookExtraInfoApi(params, bookId) {
  return request({
    url: `/api/book/extra/${bookId}`,
    method: 'get',
    params
  })
}

// 移除书架
export function removeShelfApi(data) {
  return request({
    url: '/api/shelfBook/deleteOnDetail',
    method: 'post',
    data
  })
}

// 试用申请校验
export function sampleBookCheck(data) {
  return request({
    url: `/api/sample-book/check`,
    method: 'post',
    data
  })
}

// 试用申请
export function sampleBookApply(data) {
  return request({
    url: `/api/sample-book/apply`,
    method: 'post',
    data
  })
}

//
// 试用申请相关参数：时间，总数量
export function sampleBookDays() {
  return request({
    url: `/api/sample-book/days`,
    method: 'get'
  })
}

// 书城学科目录
export function getBookAllSubjects(params) {
  return request({
    url: `/api/book/all/subjects`,
    method: 'get',
    params
  })
}

// 智能推荐
export function recommendBook(bookId) {
  return request({
    url: `/reader/section/book-recommend?bookId=${bookId}`,
    method: 'get'
  })
}